(function () {
  const CompetitorCharts = function () {
    const initRoundScoringsChart = () => {
      const chartElement = document.getElementById('round-scorings-chart');
      if (!chartElement) return;

      const chartData = JSON.parse(chartElement.dataset.chartData || '[]');
      if (!chartData || chartData.length === 0) return;

      const labels = chartData.map((item) => `R${item.round_number || item['round_number']}`);
      const scores = chartData.map((item) => {
        const score = item.score || item['score'];
        return parseFloat(score) || 0;
      });
      const roundDescriptions = chartData.map((item) => item.round_description || item['round_description'] || '');

      const computedStyle = getComputedStyle(document.documentElement);
      const barColor = computedStyle.getPropertyValue('--chart-bar-color').trim() || '#35D399';
      const bgColor = computedStyle.getPropertyValue('--chart-bg-color').trim() || '#343a40';
      const textColor = computedStyle.getPropertyValue('--chart-text-color').trim() || '#fff';

      new Chart(chartElement, {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Score',
              data: scores,
              backgroundColor: barColor,
              borderColor: barColor,
              borderWidth: 0,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: true,
              callbacks: {
                title: function (context) {
                  const index = context[0].dataIndex;
                  const description = roundDescriptions[index];
                  return description || labels[index];
                },
                label: function (context) {
                  return context.dataset.label + ': ' + context.parsed.y;
                },
              },
            },
          },
          scales: {
            x: {
              ticks: {
                color: textColor,
              },
              grid: {
                display: false,
              },
            },
            y: {
              beginAtZero: true,
              ticks: {
                color: textColor,
                callback: function (value) {
                  return value;
                },
              },
              grid: {
                color: 'rgba(255, 255, 255, 0.1)',
              },
            },
          },
        },
      });
    };

    const initHandicapChart = () => {
      const chartElement = document.getElementById('handicap-chart');
      if (!chartElement) return;

      const chartData = JSON.parse(chartElement.dataset.chartData || '[]');
      if (!chartData || chartData.length === 0) return;

      const labels = chartData.map((item) => item.round_label || item['round_label'] || '');
      const handicaps = chartData.map((item) => {
        const handicap = item.handicap || item['handicap'];
        return parseFloat(handicap) || 0;
      });

      const computedStyle = getComputedStyle(document.documentElement);
      const lineColor = computedStyle.getPropertyValue('--chart-bar-color').trim() || '#35D399';
      const bgColor = computedStyle.getPropertyValue('--chart-bg-color').trim() || '#343a40';
      const textColor = computedStyle.getPropertyValue('--chart-text-color').trim() || '#fff';

      new Chart(chartElement, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Handicap',
              data: handicaps,
              borderColor: lineColor,
              backgroundColor: 'transparent',
              borderWidth: 2,
              pointBackgroundColor: lineColor,
              pointBorderColor: lineColor,
              pointRadius: 4,
              pointHoverRadius: 6,
              tension: 0.1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: true,
            },
          },
          scales: {
            x: {
              ticks: {
                color: textColor,
              },
              grid: {
                display: false,
              },
            },
            y: {
              beginAtZero: false,
              ticks: {
                color: textColor,
                callback: function (value) {
                  return value;
                },
              },
              grid: {
                color: 'rgba(255, 255, 255, 0.1)',
              },
            },
          },
        },
      });
    };

    const init = () => {
      initRoundScoringsChart();
      initHandicapChart();
    };

    $(document).on('turbolinks:load', () => {
      setTimeout(init, 100);
    });
  };

  if (typeof window !== 'undefined') {
    window.CompetitorCharts = CompetitorCharts();
  }

  return CompetitorCharts;
})();
